import Divider from "@/components/Divider";
import LittleLoading from "@/components/LittleLoading";
import SecondaryText from "@/components/SecondaryText";
import { pos, updater as platformUpdater } from "@/platform";
import {
  MENSAJE_ACTUALIZACION_EN_ESPERA,
  puedeActualizar,
} from "@/context/caja/actualizacion";
import type { UpdateCheckResult } from "@/platform/types";
import { useState } from "react";
import { useNavigate } from "react-router";

interface UpdaterProps {
  update: UpdateCheckResult | null;
  updateParseado: {
    version: string;
  };
}

function Updater({ update, updateParseado }: UpdaterProps) {
  const [loading, setLoading] = useState(false);
  const [enEspera, setEnEspera] = useState(false);
  const navigate = useNavigate();

  const onUpdate = async () => {
    setLoading(true);
    try {
      // AC-E: con ventas de la caja sin subir, no se instala.
      if (!(await puedeActualizar(pos))) {
        setEnEspera(true);
        return;
      }
      await platformUpdater.downloadAndInstall(update?.rawUpdate);
      await platformUpdater.relaunch();
      navigate("/");
    } catch (error) {
      console.log("Error al descargar la actualización:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-999 bg-black/75 flex justify-center items-center">
      <div className="flex flex-col items-center justify-center gap-5 max-w-[600px] p-2.5">
        <div className="flex flex-col items-center justify-center gap-[5px] text-white">
          <p className="text-2xl text-white underline decoration-brand-primary decoration-[3px]">
            ¡Hay una actualización disponible!
          </p>
          <p className="text-center">
            En el equipo de Trud estamos trabajando constantemente para mejorar
            tu experiencia. Esta nueva versión incluye mejoras en el
            rendimiento, correcciones de errores y nuevas funcionalidades que te
            ayudarán a potenciar tu negocio al máximo.
          </p>
        </div>

        <Divider />

        <div className="flex flex-col items-center justify-center gap-[5px]">
          <button
            type="button"
            onClick={loading ? undefined : onUpdate}
            disabled={loading}
            className="px-5 py-2.5 bg-[var(--brand-primary)] text-[var(--white)] text-base rounded-[50px] cursor-pointer shadow-[0px_0px_0px_var(--text-1)] hover:shadow-[2px_2px_0px_var(--text-1)] transition-all duration-200 flex justify-center items-center"
          >
            {loading ? <LittleLoading /> : "Actualizar"}
          </button>
          <SecondaryText>{`Actualiza a Trud v${updateParseado.version} para continuar`}</SecondaryText>
          {enEspera && (
            <p role="status" className="text-center text-white">
              {MENSAJE_ACTUALIZACION_EN_ESPERA}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Updater;
